import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import ConfigSlice from "./slices/config.slice";

const reducer = {
  ConfigSlice,
};

export const store = configureStore({
  reducer,
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
